"use client";

function normalizeBoolean(value) {
  return value === true || value === "true" || value === 1 || value === "1";
}

export function isEmailVerified(user) {
  return Boolean(
    user?.email_verified_at
      || user?.emailVerifiedAt
      || normalizeBoolean(user?.email_verified)
      || normalizeBoolean(user?.emailVerified),
  );
}

export function isPhoneVerified(user) {
  return Boolean(
    user?.phone_verified_at
      || user?.phoneVerifiedAt
      || normalizeBoolean(user?.phone_verified)
      || normalizeBoolean(user?.phoneVerified),
  );
}

export function hasFullyVerifiedContacts(user) {
  return isEmailVerified(user) && isPhoneVerified(user);
}
